import * as n from "react";
import { useThemeProps as P } from "@mui/material/styles";
import { jsx as g } from "react/jsx-runtime";
function l() {
  return l = Object.assign ? Object.assign.bind() : function(o) {
    for (var a = 1; a < arguments.length; a++) {
      var t = arguments[a];
      for (var e in t) ({}).hasOwnProperty.call(t, e) && (o[e] = t[e]);
    }
    return o;
  }, l.apply(null, arguments);
}
function y(o, a) {
  if (o == null) return {};
  var t = {};
  for (var e in o) if ({}.hasOwnProperty.call(o, e)) {
    if (a.includes(e)) continue;
    t[e] = o[e];
  }
  return t;
}
const A = ["localeText"], v = /* @__PURE__ */ n.createContext(null), k = function(a) {
  var t;
  const {
    localeText: e
  } = a, T = y(a, A), {
    utils: i,
    localeText: c
  } = (t = n.useContext(v)) != null ? t : {
    utils: void 0,
    localeText: void 0
  }, L = P({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: T,
    name: "MuiLocalizationProvider"
  }), {
    children: M,
    dateAdapter: s,
    dateFormats: u,
    dateLibInstance: d,
    adapterLocale: p,
    localeText: m
  } = L, f = n.useMemo(() => l({}, m, c, e), [m, c, e]), r = n.useMemo(() => {
    if (!s)
      return i || null;
    const h = new s({
      locale: p,
      formats: u,
      instance: d
    });
    if (!h.isMUIAdapter)
      throw new Error(["MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return h;
  }, [s, p, u, d, i]), x = n.useMemo(() => r ? {
    minDate: r.date("1900-01-01T00:00:00.000"),
    maxDate: r.date("2099-12-31T00:00:00.000")
  } : null, [r]), j = n.useMemo(() => ({
    utils: r,
    defaultDates: x,
    localeText: f
  }), [x, r, f]);
  return /* @__PURE__ */ g(v.Provider, {
    value: j,
    children: M
  });
};
export {
  k as L,
  v as M,
  l as _,
  y as a
};
